





















































































import Campaign, { LineItem } from "@/models/campaign";
import { LayoutModule } from "@/store/layout";
import { Component, Prop, Vue } from "vue-property-decorator";
import SellersCampaignsFilter from "./SellersCampaignsFilter.vue";
import TableActions from "@/components/TableActions.vue";
import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import { exportCSVFile } from "@/helpers/general";
import moment from "moment";
import Site from "@/models/site";
import { QueryParams } from "@/models/general";
import SitesAPI from "@/services/sites";

@Component({ components: { TableActions } })
export default class SellersCampaignsDetails extends Vue {
  @Prop({ default: [] }) data!: Campaign[];
  sites: Site[] = [];

  headers = [
    {
      text: this.$t("reports.sellers_campaigns.headers.campaign"),
      sortable: false,
      value: "name",
    },
    {
      text: this.$t("reports.sellers_campaigns.headers.status"),
      sortable: false,
      value: "status",
    },
    {
      text: this.$t("reports.sellers_campaigns.headers.seller"),
      sortable: false,
      value: "user",
    },
    {
      text: this.$t("reports.sellers_campaigns.headers.company"),
      sortable: false,
      value: "company.name",
    },
    {
      text: this.$t("reports.campaign.sites"),
      sortable: false,
      value: "lineItems",
    },
    {
      text: `${this.$t("reports.sellers_campaigns.headers.discount")} (USD)`,
      sortable: false,
      value: "globalDiscount",
    },
    {
      text: `${this.$t("reports.sellers_campaigns.headers.subtotal")} (USD)`,
      sortable: false,
      value: "subTotal",
    },
    {
      text: `${this.$t("reports.sellers_campaigns.headers.total")} (USD)`,
      sortable: false,
      value: "total",
    },
    {
      text: "",
      sortable: false,
      value: "id",
    },
  ];

  async created(): Promise<void> {
    const params: QueryParams = {
      page: {
        size: -1,
      },
    };
    const r = await SitesAPI.getSites(params);
    this.sites = r.data;
  }

  getStatus(status: string): string {
    const s = CAMPAIGN_STATUS_LIST.find((s) => s.key === status);

    return s ? this.$t(s?.label).toString() : "";
  }

  goToCampaign(id: string): void {
    let routeData = this.$router.resolve({
      name: "edit-campaign",
      params: { id: id },
    });
    window.open(routeData.href, "_blank");
  }

  exportCsv(): void {
    const headers: string[] = [];
    this.headers.forEach((h) => {
      headers.push(h.text.toString());
    });
    headers.pop();
    const data: any = [];

    this.data.forEach((d) => {
      const item = {
        campaign: d.name,
        status: this.getStatus(d.status),
        seller: `${d.user?.name} ${d.user?.familyName}`,
        company: d.company?.name,
        sites: this.getSites(d.lineItems)
          .map((s) => s.abbreviation)
          .join(" | "),
        discount: d.globalDiscount,
        subtotal: d.subTotal,
        total: d.subTotal - d.globalDiscount,
      };
      console.log(item);
      data.push(item);
    });

    exportCSVFile(
      headers,
      data,
      `sellers_campaigns_${moment().format("YYYY_MM_DD")}`
    );
  }

  getSites(lineItems: LineItem[]): Site[] {
    const sitesIds: string[] = [];
    const sites: Site[] = [];
    lineItems.forEach((l) => {
      !sitesIds.includes(l.siteId) ? sitesIds.push(l.siteId) : null;
    });

    sitesIds.forEach((s) => {
      const site = this.sites.find((i) => i.id === s);
      site ? sites.push(site) : null;
    });

    return sites;
  }

  filter(): void {
    LayoutModule.setRightDrawerComponent(SellersCampaignsFilter);
    LayoutModule.showRightDrawer();
  }
}
